/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
    bool, func, object, array,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import ReactHtmlParser from 'react-html-parser';
import { getEspotById } from '../../../../../../../../../state/ducks/Common/Common-Selectors';

const styles = (theme) => ({
    modalBrackdropProps: {
        backgroundColor: theme.palette.bgPopup,
    },
    overlayContainer: {
        backgroundColor: '#FFF',
        '& h1': {
            fontSize: '20px',
            margin: '20px 0px',
        },
        '& h2': {
            fontSize: '16px',
            margin: '20px 0px',
        },
        '& .cpTermsWrapper': {
            height: '90%',
            overflow: 'auto',
            position: 'absolute',
            background: '#fff',
            width: '95%',
            margin: '0 auto',
            padding: '5px',
        },
    },
    modelOverflow: {
        overflow: 'auto',
    },
    modalContainer: {
        backgroundColor: theme.palette.grey1,
        padding: '34px 4px',
    },
    headingText: {
        color: theme.palette.white,
        textTransform: 'uppercase',
        fontSize: '16px',
        lineHeight: '48px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        margin: '0',
        padding: '0 8px',
        fontWeight: 'normal',
    },
    right: {
        right: '10px',
        position: 'absolute',
        fontSize: '20px',
        fontWeight: '100',
        top: '-7px',
        padding: '0px 10px',
        textAlign: 'center',
    },
});

class PassportTnCModal extends PureComponent {
    render() {
        const {
            classes, closeModal, modalStatus, contentPassportTnC,
        } = this.props;

        let marketingTextHTML = '';
        if (contentPassportTnC && contentPassportTnC.length > 0) {
            const [tncContent] = contentPassportTnC;
            const [baseMarketingSpotActivityData] = tncContent.baseMarketingSpotActivityData;
            const { marketingContentDescription } = baseMarketingSpotActivityData;
            const [contentData] = marketingContentDescription;
            marketingTextHTML = contentData.marketingText;
        }

        return (
            <Modal
                BackdropProps={{ classes: { root: classes.modalBrackdropProps } }}
                className={classes.modelOverflow}
                open={modalStatus}
            >
                <div className={classes.modalContainer}>
                    <h1 className={classes.headingText}>
                        <span
                            className={classes.right}
                            onClick={() => { closeModal(); }}
                            onKeyDown={() => { }}
                            role="button"
                            tabIndex={-1}
                        >
                            X
                        </span>
                    </h1>
                    <div className={classes.overlayContainer}>
                        { ReactHtmlParser(marketingTextHTML) }
                    </div>
                </div>
            </Modal>
        );
    }
}

PassportTnCModal.propTypes = {
    classes: object.isRequired,
    modalStatus: bool.isRequired,
    closeModal: func.isRequired,
    contentPassportTnC: array,
};

PassportTnCModal.defaultProps = {
    contentPassportTnC: [],
};

const mapStateToProps = (state) => ({
    contentPassportTnC: getEspotById(state, 'PWAPassportTerms_lander-body'),
});

export default connect(mapStateToProps)(withStyles(styles)(PassportTnCModal));
